import {analysis} from './constants';

export const analyzer = {
    check_balance(item) {
        let terms = eval(item.terms);
        if (!terms || terms.length === 0) {
            return {
                min: undefined,
                max: undefined,
                severity: analysis.NONE
            };
        }

        let max = _max(terms);
        let min = _min(terms);

        var result = {
            min: min,
            max: max,
            severity: undefined
        }

        let ratio = max.docCount / min.docCount;
        if (ratio > analysis.FATAL_BALANCE) {
            result.severity = analysis.FATAL
        } else if (ratio > analysis.WARNING_BALANCE) {
            result.severity = analysis.WARNING;
        } else {
            result.severity = analysis.NONE;
        }

        return result;
    },

    check_cardinality(item) {
        if (item.cardinality < analysis.FATAL_CARDINALITY) {
            return analysis.FATAL;
        }

        if (item.cardinality < analysis.WARNING_CARDINALITY) {
            return analysis.WARNING;
        }

        return analysis.NONE;
    },

    severity(item) {
        let bSeverity = this.check_balance(item);
        let cSeverity = this.check_cardinality(item);
        var minSev = analysis.FATAL;
        if (item.type === 'cat') {
            minSev = Math.min(bSeverity.severity, cSeverity);
        } else if (item.type === 'txt') {
            minSev = cSeverity;
        } else {
            if (item.count < 200)
                minSev = analysis.FATAL;
            else if (item.count >= 200 && item.count < 500)
                minSev = analysis.WARNING;
            else
                minSev = analysis.NONE;
        }

        return minSev;
    }
}

function _max(arr) {
    return arr.reduce(function (prev, current) {
        return prev.docCount > current.docCount ? prev : current;
    });
}

function _min(arr) {
    return arr.reduce(function (prev, current) {
        return prev.docCount < current.docCount ? prev : current;
    });
}

export default analyzer;